/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".customWidthModal{max-width:1000px;min-width:1000px}.rowPartEven{background-color:var(--background-tableroweven)!important;color:var(--foreground-tableroweven)!important}.rowPartOdd{background-color:var(--background-tablerowodd)!important;color:var(--foreground-tablerowodd)!important}.rowPart:hover,.rowPartSelected{background-color:var(--background-tablerowselect)!important;color:var(--foreground-tablerowselect)!important}"];
export { styles as styles };
